import React from 'react';

import {
  Container,
  Text,
} from './styles';

const WrongBrowser = () => (
  <Container>
    <Text>You&apos;re using the wrong browser!</Text>
    <Text>Please use Chrome to complete this study.</Text>
  </Container>
);

export default WrongBrowser;
